export default function () {
	const calculator = document.querySelector('.js-forex-calculator');

	if(!calculator) {
		return;
	}
	
	const firstCurrency   = calculator.querySelector('#first-currency');
	let firstCurrencyVal  = firstCurrency.options[firstCurrency.selectedIndex].value;
	const secondCurrency  = calculator.querySelector('#second-currency');
	let secondCurrencyVal = firstCurrency.options[firstCurrency.selectedIndex].value;
	
	const swapLong 		 = calculator.querySelector('#swap-long');
	const swapShort 	 = calculator.querySelector('#swap-short');
	const swapTypeLong 	 = calculator.querySelector('#swap-type-l');
	const swapTypeShort  = calculator.querySelector('#swap-type-s');
	const digitsLong 	 = calculator.querySelector('#digits-l');
	const digitsShort 	 = calculator.querySelector('#digits-s');
	const contractLong 	 = calculator.querySelector('#contract-l');
	const contractShort  = calculator.querySelector('#contract-s');
	const priceSpanMinus = calculator.querySelector('#price-span-minus');
	const priceSpanPlus  = calculator.querySelector('#price-span-plus');
	const leverageShort  = calculator.querySelector('#leverage-l');
	const leverageLong 	 = calculator.querySelector('#leverage-s');
	const stopOutLong 	 = calculator.querySelector('#stop-out-l');
	const stopOutShort 	 = calculator.querySelector('#stop-out-s');
	const spreadLong 	 = calculator.querySelector('#spread-l');
	const spreadShort 	 = calculator.querySelector('#spread-s');
	const tripleDayLong  = calculator.querySelector('#triple-day-l');
	const tripleDayShort = calculator.querySelector('#triple-day-s');
	const brokerLong 	 = calculator.querySelector('#broker-l');
	const brokerShort 	 = calculator.querySelector('#broker-s');

	const deals = document.querySelector('.js-deal-forex');

	const returnDeal   = deals.querySelector('.js-return-deal');
	const fundBroker1  = deals.querySelector('#fund-broker-1');
	const priceBroker1 = deals.querySelector('#price-broker-1');
	const fundBroker2  = deals.querySelector('#fund-broker-2');
	const priceBroker2 = deals.querySelector('#price-broker-2');
	const tradeCosts   = deals.querySelector('#trade-costs');
	const multiplier   = deals.querySelector('#multiplier');
	


	
	let dealsCalculation = () => {
		if(swapShort.value == '24') {
			returnDeal.innerHTML = '3.14';
		} else {
			returnDeal.innerHTML = '3.52';
		}
		fundBroker1.value = '29';
		priceBroker1.value = '0.01';
		fundBroker2.value = '24';
		priceBroker2.value = '0.01';
		multiplier.value = '1.000';
		if(swapShort.value == '24') {
			tradeCosts.value = '7.0';
		} else {
			tradeCosts.value = '6.2';
		}
	}

	spreadShort.addEventListener("focusout", dealsCalculation);
	
};